const Footer = () => {
    return (
        <footer className="footer">
            <p>&copy;2021 All Rights Reserved- Amrik, Marko, Yash</p>


        </footer>
    );
}
 
export default Footer;